function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Icons/Instagram");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  x1: "50%",
  y1: "99.7089109%",
  x2: "50%",
  y2: "0.776721582%",
  id: "linearGradient-1"
}, React.createElement("stop", {
  stopColor: "#FBB250",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#F36566",
  offset: "30.2496833%"
}), React.createElement("stop", {
  stopColor: "#EA4DA2",
  offset: "61.0166807%"
}), React.createElement("stop", {
  stopColor: "#9848F2",
  offset: "100%"
})));

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  id: "All-Screens",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Home---1820x1024",
  transform: "translate(-1549.000000, -140.000000)",
  fill: "url(#linearGradient-1)"
}, React.createElement("g", {
  id: "Popup-Copy",
  transform: "translate(1530.000000, 84.000000)"
}, React.createElement("g", {
  id: "Icons/Instagram",
  transform: "translate(16.000000, 53.000000)"
}, React.createElement("g", {
  id: "instagram-(2)",
  transform: "translate(3.000000, 3.000000)"
}, React.createElement("path", {
  d: "M9.81212319,4.4408921e-15 C12.1077935,4.4408921e-15 13.9755,1.86768116 13.9755,4.16337681 L13.9755,9.81212319 C13.9755,12.1078188 12.1078188,13.9755 9.81212319,13.9755 L4.16337681,13.9755 C1.86768116,13.9755 1.86517468e-14,12.1078188 1.86517468e-14,9.81212319 L1.86517468e-14,4.16337681 C1.86517468e-14,1.86768116 1.86768116,4.4408921e-15 4.16337681,4.4408921e-15 L9.81212319,4.4408921e-15 Z M12.5695652,9.81212319 L12.5695652,4.16337681 C12.5695652,2.64047101 11.3350036,1.40593478 9.81212319,1.40593478 L4.16337681,1.40593478 C2.64049638,1.40593478 1.40593478,2.64047101 1.40593478,4.16337681 L1.40593478,9.81212319 C1.40593478,11.3350036 2.64049638,12.5695652 4.16337681,12.5695652 L9.81212319,12.5695652 C11.3350036,12.5695652 12.5695652,11.3350036 12.5695652,9.81212319 Z M6.98775,3.37318841 C8.98082246,3.37318841 10.6023116,4.99465217 10.6023116,6.98772464 C10.6023116,8.9807971 8.98082246,10.6022862 6.98775,10.6022862 C4.99467754,10.6022862 3.37318841,8.98077174 3.37318841,6.98772464 C3.37318841,4.99467754 4.99467754,3.37318841 6.98775,3.37318841 Z M6.98775,9.19637681 C8.20752536,9.19637681 9.19637681,8.20752536 9.19637681,6.98775 C9.19637681,5.76794928 8.20755072,4.77912319 6.98775,4.77912319 C5.76797464,4.77912319 4.77912319,5.76794928 4.77912319,6.98775 C4.77912319,8.20755072 5.76794928,9.19637681 6.98775,9.19637681 Z M10.6093116,4.26644928 C10.130965,4.26644928 9.74318841,3.87867272 9.74318841,3.40032609 C9.74318841,2.92197946 10.130965,2.5342029 10.6093116,2.5342029 C11.0876582,2.5342029 11.4754348,2.92197946 11.4754348,3.40032609 C11.4754348,3.87867272 11.0876582,4.26644928 10.6093116,4.26644928 Z",
  id: "Combined-Shape",
  fillRule: "nonzero"
}))))));

var SvgInstagram = function SvgInstagram(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    ref: svgRef
  }, props), title === undefined ? _ref2 : React.createElement("title", null, title), _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgInstagram, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/instagram.14f0412d.svg";
export { ForwardRef as ReactComponent };